import React from "react";
import Loadable from "@loadable/component";
import { fontsName } from "../assets/fonts/fontsName";
// import img5 from "../assets/images/blog/best1.jpg";
// import img6 from "../assets/images/blog/best2.jpg";
// import img7 from "../assets/images/blog/best3.jpg";
import shape1 from "../assets/images/shape/vector-shape9.png";
import shape2 from "../assets/images/shape/vector-shape10.png";
import { request, gql } from "graphql-request";
import { REQUEST_URL } from "./RequestUrl";
// import Birthday from "../assets/images/bitrhday.jpg";
import axios from "axios";
import userProfile from "../assets/images/user-avatar.png";
import BestStudentPart from "./BestStudentPart";
const OwlCarousel = Loadable(() => import("react-owl-carousel3"));

// const options = {
//   loop: true,
//   nav: true,
//   dots: false,
//   autoplayHoverPause: false,
//   autoplay: true,
//   margin: 30,
//   navText: [
//     "<i class='flaticon-left-1'></i>",
//     "<i class='flaticon-right-1'></i>",
//   ],
//   responsive: {
//     0: {
//       items: 1,
//     },
//     768: {
//       items: 3,
//     },
//     992: {
//       items: 3,
//     },
//   },
// };
const options = {
  loop: true,
  nav: false,
  dots: true,
  autoplayHoverPause: true,
  autoplay: true,
  margin: 10,
  navText: [
    "<i class='flaticon-left-1'></i>",
    "<i class='flaticon-right-1'></i>",
  ],
  responsive: {
    0: {
      items: 1,
    },
    768: {
      items: 2,
    },
    992: {
      items: 2,
    },
  },
};

const optionsTwo = {
  loop: true,
  nav: false,
  dots: false,
  autoplayHoverPause: true,
  autoplay: true,
  margin: 10,
  navText: [
    "<i class='flaticon-left-1'></i>",
    "<i class='flaticon-right-1'></i>",
  ],
  responsive: {
    0: {
      items: 1,
    },
    768: {
      items: 1,
    },
    992: {
      items: 1,
    },
  },
};

const BEST_STUDENTS = gql`
  {
    getAllWebsiteTopStudents {
      _id
      fullName
      level
      pictureLink
    }
  }
`;

const BestStudents = () => {
  const [display, setDisplay] = React.useState(false);
  const [bestStudentsList, setBestStudentsList] = React.useState([]);
  const [studentsBirthday, setStudentsBirthday] = React.useState();

  React.useEffect(() => {
    request(REQUEST_URL, BEST_STUDENTS).then((data) => {
      setBestStudentsList(data.getAllWebsiteTopStudents);
    });
  }, []);

  React.useEffect(() => {
    setDisplay(true);
  }, []);

  React.useEffect(() => {
    axios
      .get("/sms-api/get-list-of-person-birthday")
      .then((res) => {
        setStudentsBirthday(res.data);
      })
      .catch((err) => { });
  }, []);

  return (
    <>
      <div className="project-start-area bg-color ptb-100">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-4 col-md-12 col-xs-12">
              <div className="section-title">
                <h2 style={{ fontFamily: fontsName.Vazir, color: "#fff" }}>
                  تولد ها
                </h2>
                <p
                  style={{
                    width: "25%",
                    height: "4px",
                    backgroundColor: "#FFFF00",
                    marginTop: "20px",
                  }}
                ></p>
              </div>
              {display ? (
                <OwlCarousel
                  className="testimonials-slides  owl-carousel owl-theme"
                  {...optionsTwo}
                >
                  {studentsBirthday &&
                    studentsBirthday.status == "SUCCES" &&
                    studentsBirthday.people !== null
                    ? studentsBirthday.people.length > 0
                      ? studentsBirthday.people.map((student, index) => (
                        <div
                          key={index}
                          className="background-birthdate-container"
                        // style={{
                        //   width: "100%",
                        //   textAlign: "center",
                        //   backgroundColor: "#fff",
                        //   height: "70vh",
                        //   borderRadius: "15px",
                        //   position: "relative",
                        // }}
                        >
                          <div
                            className="background-birthdate"
                          // style={{
                          //   borderRadius: "15px",
                          //   width: "100%",
                          //   height: "100%",
                          // }}
                          >
                            <img
                              src={
                                student.hasOwnProperty("photoURL")
                                  ? student.photoURL !== null &&
                                    student.photoURL !== "null" &&
                                    student.photoURL !== ""
                                    ? student.photoURL
                                    : userProfile
                                  : userProfile
                              }
                              alt="best-student"
                              className="background-birthdate-img"
                            // style={{
                            //   height: "200px",
                            //   width: "200px",
                            //   borderRadius: "50%",
                            //   position: "absolute",
                            //   top: "20%",
                            //   left: "20%",
                            // }}
                            />
                          </div>

                          <div
                            className="background-birthdate-content"
                            style={{
                              fontFamily: fontsName.Vazir,
                            }}
                          >
                            <h3
                              style={{
                                direction: "rtl",
                                fontFamily: fontsName.Vazir,
                                textAlign: "right",
                              }}
                            >
                              {student.person_name +
                                " " +
                                student.person_surname}
                            </h3>
                            <p
                              style={{
                                direction: "rtl",
                                fontFamily: fontsName.Vazir,
                                textAlign: "center",
                                fontSize: "20px",
                              }}
                            >
                              تولدت مبارک
                            </p>
                          </div>
                        </div>
                      ))
                      : ""
                    : ""}
                </OwlCarousel>
              ) : (
                ""
              )}
            </div>

            <div className="col-lg-8 col-md-12 col-xs-12">
              <div className="section-title">
                <h2 style={{ fontFamily: fontsName.Vazir, color: "#fff" }}>
                  دانش آموزان برتر
                </h2>
                <p
                  style={{
                    width: "25%",
                    height: "4px",
                    backgroundColor: "#FFFF00",
                    marginTop: "20px",
                  }}
                ></p>
              </div>
              {display ? (
                <OwlCarousel
                  className="testimonials-slides  owl-carousel owl-theme"
                  {...options}
                >
                  {bestStudentsList && bestStudentsList.length > 0
                    ? bestStudentsList.map((student, index) => (
                      <BestStudentPart key={index} student={student} />
                    ))
                    : ""}
                </OwlCarousel>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>

        {/* <div className="lg-col-6 sm-col-12">
          <div className="container">
            <div className="section-title">
              <h2 style={{ fontFamily: fontsName.Vazir, color: "#fff" }}>
                تولدها
              </h2>
              <p
                style={{
                  width: "25%",
                  height: "4px",
                  backgroundColor: "#FFFF00",
                  marginTop: "20px",
                }}
              ></p>
            </div>
            {display ? (
              <OwlCarousel
                className="testimonials-slides  owl-carousel owl-theme"
                {...options}
              >
                {bestStudentsList && bestStudentsList.length > 0
                  ? bestStudentsList.map((student, index) => (
                      <div className="single-blog-post bg-fffbf5" key={index}>
                        <div className="post-image">
                          <img
                            src={student.pictureLink}
                            alt="best-student"
                            style={{ height: "350px" }}
                          />
                        </div>

                        <div
                          className="post-content"
                          style={{
                            direction: "rtl",
                            fontFamily: fontsName.Vazir,
                          }}
                        >
                          <h3
                            style={{
                              direction: "rtl",
                              fontFamily: fontsName.Vazir,
                              textAlign: "right",
                            }}
                          >
                            {student.fullName}
                          </h3>
                          <p
                            style={{
                              direction: "rtl",
                              fontFamily: fontsName.Vazir,
                              textAlign: "right",
                              paddingTop: "5px",
                              fontSize: "20px",
                            }}
                          >
                            {student.level}
                          </p>
                        </div>
                      </div>
                    ))
                  : ""}
              </OwlCarousel>
            ) : (
              ""
            )}
          </div>
        </div> */}

        <div className="vector-shape9">
          <img src={shape1} alt="shape" />
        </div>
        <div className="vector-shape10">
          <img src={shape2} alt="shape" />
        </div>
      </div>
    </>
  );
};

export default BestStudents;
